import { orgTeams, notify } from '../wiring'
import { createTeam } from '../application/create-team'
import { deleteTeam } from '../application/delete-team'
import { addLeader, addMember, removeLeader, removeMember } from '../application/manage-team-membership'
import { updateTeam } from '../application/update-team'

const useOrgTeamActions = () => {
	const addTeam = (input: Parameters<typeof createTeam>[1]) =>
		createTeam(orgTeams, input, notify)

	const editTeam = (id: string, input: Parameters<typeof updateTeam>[2]) =>
		updateTeam(orgTeams, id, input, notify)

	const removeTeam = (id: string) =>
		deleteTeam(orgTeams, id, notify)

	const addTeamMember = (teamId: string, memberId: string) =>
		addMember(orgTeams, teamId, memberId, notify)

	const removeTeamMember = (teamId: string, memberId: string) =>
		removeMember(orgTeams, teamId, memberId, notify)

	const addTeamLeader = (teamId: string, memberId: string) =>
		addLeader(orgTeams, teamId, memberId, notify)

	const removeTeamLeader = (teamId: string, memberId: string) =>
		removeLeader(orgTeams, teamId, memberId, notify)

	return { addTeam, editTeam, removeTeam, addTeamMember, removeTeamMember, addTeamLeader, removeTeamLeader }
}

export { useOrgTeamActions }
